export * from "./StateTypes";
export * from "./genericTypes";
export * from "./gqlTypes";

declare global {
  interface Window {
    cloudinary: any;
  }
}
